const mutation = `mutation customerUpdate($input: CustomerUpdateInput!) {
  customerUpdate(input: $input) {
    userErrors {
      field
      message
    }
    customer {
      firstName
      lastName
    }
  }
}
`

export default mutation
